import { render, staticRenderFns } from "./InspectionsList.vue?vue&type=template&id=6386bcb6&scoped=true&"
import script from "./InspectionsList.vue?vue&type=script&lang=js&"
export * from "./InspectionsList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionsList.vue?vue&type=style&index=0&id=6386bcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386bcb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemTitle,VRow,VSubheader})
